import{__assign as r}from"../../../node_modules/tslib/tslib.es6.js";import{j as e}from"../../../node_modules/react/jsx-runtime.js";import{Box as o}from"@mui/material";var i=function(i){return e.jsx(o,r({sx:{marginTop:12}},i,{children:i.children}))};export{i as default};
//# sourceMappingURL=index.js.map
